import i18n from "src/i18n";
import * as Yup from "yup";

// Messages are functions so they read the active language when validation runs.
const email = Yup.string()
  .email(() =>
    i18n.t("auth.invalidEmail", { defaultValue: "Enter a valid email" }),
  )
  .required(() =>
    i18n.t("auth.invalidEmail", { defaultValue: "Enter a valid email" }),
  );

/** Email step: only the address is on screen, so only the address is validated. */
export const emailStepSchema = Yup.object().shape({ email });

/** Password step (districts without single sign-on). */
export const loginStepSchema = Yup.object().shape({
  email,
  password: Yup.string().required(() =>
    i18n.t("auth.passwordRequired", { defaultValue: "Enter your password." }),
  ),
});

/** @deprecated kept for callers that validate both fields at once */
const loginValidationSchema = loginStepSchema;

export default loginValidationSchema;
